import React, { useState, useEffect } from "react";
import { Drawer, IconButton, List } from "@material-ui/core";
import {
  ArrowBack,
  Dashboard,
} from "@material-ui/icons";
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import DescriptionIcon from '@mui/icons-material/Description';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import CategoryIcon from '@mui/icons-material/Category';
import ListAltIcon from '@mui/icons-material/ListAlt';
import GradingIcon from '@mui/icons-material/Grading';
import { useTheme } from "@material-ui/styles";
import { withRouter } from "react-router-dom";

import classNames from "classnames";

// styles
import useStyles from "./styles";

// components
import SidebarLink from "./components/SidebarLink/SidebarLink";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";


function SidebarCustomerService({ location, ...props }) {
  var classes = useStyles();
  var theme = useTheme();

  //var props = useParams();

  // global
  var { isSidebarOpened } = useLayoutState();
  var layoutDispatch = useLayoutDispatch();

  // local
  var [isPermanent, setPermanent] = useState(true);

  useEffect(function() {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  let structure = [
    //{ id: 13, label: "Dashboard", link: "/service/dashboard", icon: <Dashboard /> },
    //{ id: 12, type: "divider" },
    { id: 2, label: "Ordini", link: "/service/ordini", icon: <ListAltIcon /> },
    { id: 19, label: "Ordini Fornitori", link: "/service/ordini-fornitori", icon: <GradingIcon /> },
    { id: 16, type: "divider" },
    { id: 14, label: "Fornitori", link: "/service/fornitori", icon: <CategoryIcon /> },
    { id: 17, label: "Prodotti", link: "/service/prodotti", icon: <LocalShippingIcon /> },
    { id: 18, type: "divider" },
    { id: 23, label: "Giacenze Magazzino", link: "/service/giacenze-magazzino", icon: <WarehouseIcon /> },
    { id: 20, label: "Ddt", link: "/service/ddt", icon: <DescriptionIcon /> },
  ];

  return (
    <Drawer
      variant={isPermanent ? "permanent" : "temporary"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
    style={{position: 'sticky'}}

    >
      <div className={classes.toolbar} />
      <div className={classes.mobileBackButton}>
        <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
          <ArrowBack
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse),
            }}
          />
        </IconButton>
      </div>
      <List className={classes.sidebarList} >

        <img alt="" src={require('../../images/logo_sisma.png')} style={{position: 'relative', width: '90%', marginBottom: '20px', marginTop: '20px', left: '5%'}} />
        {structure.map(link => (
          <SidebarLink
            key={link.id}
            location={location}
            isSidebarOpened={isSidebarOpened}
            {...link}
          />
        ))}
      </List>
    </Drawer>
  );

  // ##################################################################
  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.md;
    var isSmallScreen = windowWidth < breakpointWidth;

    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }
}

export default withRouter(SidebarCustomerService);
